import styled from 'styled-components';
import { select } from '@panel/commons/core/themev2';

const ContactDataContainer = styled.div`
  width: 100%;
  min-height: 350px;
  display: flex;
  margin-top: ${({ device }) => (device === 'desktop' ? '24px' : '32px')};
  flex-direction: ${({ device }) => (device !== 'mobile' ? 'row' : 'column')};
  gap: ${({ device }) => (device !== 'tablet' ? '40px' : '24px')};
`;

const SectionContainer = styled.div`
  display: block;
  width: ${({ device }) => {
    if (device === 'desktop') return '42%';
    if (device === 'tablet') return '50%';
    return '100%';
  }};
  max-height: 700px;
  overflow: hidden;
`;

const SectionPreview = styled.div`
  width: ${({ device }) => {
    if (device === 'desktop') return '58%';
    if (device === 'tablet') return '50%';
    return '100%';
  }};
  display: flex;
  overflow: hidden;
`;

const AlertContainer = styled.div`
  width: 100%;
  margin-top: 30px;
`;

const StyledRowDropdowns = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: space-evenly;
  text-transform: capitalize;
  button {
    height: 30px;
    padding: 4px 8px;
    line-height: initial;
    text-transform: capitalize;
    border: 0;
  }
  button:hover {
    border: 0;
  }
  ul {
    overflow-y: scroll;
    max-height: 200px;
  }
  > div > div {
    min-width: 97px;
  }
`;

const Title = styled.div`
  width: 100%;
  font-family: Hind;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-align: left;
  margin-bottom: 8px;
  @media (max-width: 820px) {
    width: 100%;
  }
`;

const DropDownAcordion = styled.div`
  height: fit-content;
  width: 80%;
  @media (min-width: 1366px) {
    margin-left: 0;
    margin-right: 0;
    width: auto;
  }
  @media (max-width: 820px) {
    margin-left: 18px;
    margin-right: 18px;
    width: auto;
  }
`;

const LineBottom = styled.hr`
  background-color: ${select('middleGray')};
  height: 1px;
  width: 100%;
  margin-top: 24px;
`;

const Answer = styled.div`
  font-family: Hind;
  font-size: 14px;
  font-weight: 400;
  line-height: 25.62px;
  color: ${({ permission }) => (permission ? select('black') : select('midLightGray'))};
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  padding-top: 3%;
  padding-bottom: 2%;
  padding-left: 3%;
  padding-right: 3%;
  width: 100%;
  cursor: ${({ permission }) => (permission ? 'pointer' : 'not-allowed')};
  :hover {
    background-color: ${({ permission }) => (permission ? select('neutralGray') : null)};
    color: ${({ permission }) => (permission ? select('black') : null)};
    font-weight: ${({ permission }) => (permission ? '600' : null)};
  }
`;

export {
  ContactDataContainer,
  SectionContainer,
  AlertContainer,
  StyledRowDropdowns,
  Title,
  DropDownAcordion,
  LineBottom,
  Answer,
  SectionPreview
};
